import React from 'react';
import { CellPlugin } from '@react-page/editor';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import { ColorPickerField } from '@react-page/editor';

export interface SimpleContainerData extends Record<string, unknown> {
  backgroundColor?: string;
  padding?: number;
  textAlign?: 'left' | 'center' | 'right';
  border?: boolean;
  borderColor?: string;
  visibility?: 'all' | 'hide-mobile' | 'mobile-only';
}

export function createSimpleContainerPlugin(): CellPlugin<SimpleContainerData> {
  return {
    id: 'simple-container',
    title: 'Container',
    description: 'Wrap content with customizable styles',
    icon: <CropSquareIcon />,
    version: 2,

    Renderer: ({ children, data }) => {
      const visibilityClass = data.visibility === 'hide-mobile' ? 'hide-mobile' : data.visibility === 'mobile-only' ? 'mobile-only' : '';
      return (
        <div
          className={visibilityClass}
          style={{
            backgroundColor: data.backgroundColor ?? '#ffffff',
            padding: `${data.padding ?? 20}px`,
            textAlign: data.textAlign ?? 'left',
            border: data.border ? `1px solid ${data.borderColor ?? '#000'}` : 'none',
            transition: 'all 0.3s ease',
          }}
        >
          {children}
        </div>
      );
    },

    controls: {
      type: 'autoform',
      schema: {
        type: 'object',
        required: [],
        properties: {
          backgroundColor: {
            type: 'string',
            title: 'Background Color',
            default: '#ffffff',
            uniforms: {
              component: ColorPickerField,
            },
          } as any,
          padding: {
            type: 'number',
            title: 'Padding (px)',
            default: 20,
          } as any,
          textAlign: {
            type: 'string',
            title: 'Text Alignment',
            enum: ['left', 'center', 'right'],
            default: 'left',
          } as any,
          border: {
            type: 'boolean',
            title: 'Show Border',
            default: false,
          } as any,
          borderColor: {
            type: 'string',
            title: 'Border Color',
            default: '#000000',
            uniforms: {
              component: ColorPickerField,
            },
          } as any,
          visibility: {
            type: 'string',
            title: 'Visibility',
            enum: ['all', 'hide-mobile', 'mobile-only'],
            default: 'all',
          } as any,
        },
      },
    },
  };
}
